import { memo, useCallback, useState } from 'react'
import { GS } from 'back-end-api'
import { useTranslation } from 'services/Translation'

import texts from './texts'
import { LinkRow, PrimaryButton, SubHeading, Notice } from './Styles'

// Task 15.4 — Stripe wallet link and redirect (Requirements 11.1, 11.3, 11.4, 11.6).
//
// This control is rendered ONLY when the doctor is onboarded (the parent gates
// on `bank_details_set === true`, satisfying 11.1 / 11.4). Clicking it calls
// GS.createWalletLoginLink() and redirects to the returned url on success; on
// failure it surfaces an in-place error notification WITHOUT navigating (11.6).
const StripeWalletLink = () => {
  const { t } = useTranslation(texts)
  const [loading, setLoading] = useState(false)
  const [errored, setErrored] = useState(false)

  const openWallet = useCallback(async () => {
    setErrored(false)
    setLoading(true)
    try {
      const res = await GS.createWalletLoginLink()
      const url = res?.data?.url
      if (res?.error || !url) {
        // Surface the error in place and stay on the current view (11.6).
        setErrored(true)
        setLoading(false)
        return
      }
      window.location.href = url
    } catch {
      setErrored(true)
      setLoading(false)
    }
  }, [])

  return (
    <LinkRow data-cy="stripeWalletLink">
      <div>
        <PrimaryButton
          type="button"
          onClick={openWallet}
          disabled={loading}
          data-cy="stripeWalletButton"
        >
          {loading ? t('walletLinkLoading') : t('openStripeWallet')}
        </PrimaryButton>
        <SubHeading>{t('stripeWalletHint')}</SubHeading>
      </div>

      {errored && (
        <Notice variant="error" data-cy="stripeWalletError">
          {t('walletLinkError')}
        </Notice>
      )}
    </LinkRow>
  )
}

StripeWalletLink.whyDidYouRender = true

export default memo(StripeWalletLink)
